import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsTool, PmsTool } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsTool>
    useData={usePmsTool}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
